module.exports = __webpack_public_path__ + "img/selfServiceImg2.e0d327e.svg";